import { handleGetRequest, handlePostRequest } from "./http.service";

export interface GuarantorUser {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
}

export interface Guarantor {
  _id: string;
  fullName: string;
  email?: string;
  phone?: string;
  relationship?: string;
  occupation?: string;
  gid?: string;
  status: "Awaiting Response" | "Responded" | "Verified";
  consent: "Pending" | "Approved" | "Denied";
  user?: GuarantorUser;
  createdAt: string;
}

export interface GuarantorsResponse {
  page: number;
  limit: number;
  total: number;
  data: Guarantor[];
}

export const getAllGuarantors = async (params?: {
  page?: number;
  limit?: number;
}) => {
  const qs = new URLSearchParams();
  if (params?.page) qs.set("page", String(params.page));
  if (params?.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs}` : "";
  return handleGetRequest<GuarantorsResponse>(`/admins/guarantors${query}`);
};

export const verifyGuarantor = async (id: string) =>
  handlePostRequest(`/admins/verify-guarantor/${id}`, {});
